import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo3/selva.png";
import Imagen2 from "../../../images/modulo3/sierra.png";
import Imagen3 from "../../../images/modulo3/costa.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo3 } from "../../../routes/Module3";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo3/Actividad 1.mp3";

const Actividad1 = () => {
  const infoUnidad = modulo3.content[0];
  const infoAct = modulo3.content[0].activities[0];
  const crumbs = [
    {
      title: modulo3.title,
      url: "/" + modulo3.url,
    },
    {
      title:
        modulo3.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo3.content[0].activities[1].name}`,
    linkNext: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[1].path}`,
    titlePrev: modulo3.title,
    linkPrev: modulo3.url,
  };
  const metadata = {
    color: modulo3.color,
    title: `${modulo3.title} - ${infoAct.name}`,
    name: modulo3.title
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-md-8">
          <p>
            <small className={`c-${modulo3.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

          <ul>
            <li>
              Las escuelas que encontramos en todo el territorio del Perú son
              muy diversas.
            </li>
            <li>Observa las imágenes, ¿qué ves en ellas?</li>
            <li>
              Luego, toma un papel en blanco y dibuja algo que te guste de tu
              escuela.
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-12 mb-4">
          <img src={Imagen1} className="img-fluid" alt="Grupo" />
        </div>
        <div className="col-lg-4 col-md-6 col-12 mb-4">
          <img src={Imagen2} className="img-fluid" alt="Grupo" />
        </div>
        <div className="col-lg-4 col-md-6 col-12 mb-4">
          <img src={Imagen3} className="img-fluid" alt="Grupo" />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Pregunte qué se ve en las imágenes. Resalte que en el Perú existen
          diversos tipos de escuelas. Por ejemplo, en la imagen 1 podemos ver
          cómo son algunas de las escuelas en la selva. Finalmente, dialoguen
          acerca de lo que dibujaron y qué es lo que más les gusta de su
          escuela.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
